export default {
  // 获取记账本类型
  getTallyType: {
    url: '/api/getTallyType',
    method: 'get'
  },
  // 添加记账本类型
  createTallyType: {
    url: '/api/createTallyType',
    method: 'post'
  },
  // 删除类型
  deleteTallyType: {
    url: '/api/deleteTallyType',
    method: 'delete'
  },
  // 获取记账本信息
  getTallyBook: {
    url: '/api/getTallyBook',
    method: 'get'
  },
  // 创建记账本信息
  createTallyBook: {
    url: '/api/createTallyBook',
    method: 'post'
  },
  // 更新记账本信息
  updateTallyBook: {
    url: '/api/updateTallyBook',
    method: 'put'
  },
  // 删除记账本信息
  deleteTallyBook: {
    url: '/api/deleteTallyBook',
    method: 'delete'
  },
  // 类别记录信息
  countTallyBook: {
    url: '/api/countTallyBook',
    method: 'get'
  }
}
